/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 9L12 3L16 9M8 9H16M8 9L12 21L16 9M8 9H2.5M16 9H21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 21L3.20809 10.9521C2.59911 10.2561 2.29462 9.90813 2.16812 9.51342C2.05656 9.16531 2.04254 8.79328 2.12759 8.43775C2.22402 8.03464 2.50146 7.66472 3.05633 6.92489L5.04 4.28C5.392 3.81067 5.568 3.576 5.79105 3.40675C5.9886 3.25685 6.21232 3.14499 6.45077 3.07689C6.72 3 7.01334 3 7.6 3H12H16.4C16.9867 3 17.28 3 17.5492 3.07689C17.7877 3.14499 18.0114 3.25685 18.209 3.40675C18.432 3.576 18.608 3.81067 18.96 4.28L20.9437 6.92489C21.4985 7.66472 21.776 8.03464 21.8724 8.43775C21.9575 8.79328 21.9434 9.16531 21.8319 9.51342C21.7054 9.90813 21.4009 10.2561 20.7919 10.9521L12 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M9.59175 18.2477L3.20809 10.9521C2.59911 10.2561 2.29462 9.90813 2.16812 9.51342C2.05656 9.16531 2.04254 8.79328 2.12759 8.43775C2.22402 8.03464 2.50146 7.66472 3.05633 6.92489L5.04 4.28C5.392 3.81067 5.568 3.576 5.79105 3.40675C5.9886 3.25685 6.21232 3.14499 6.45077 3.07689C6.72 3 7.01334 3 7.6 3H16.4C16.9867 3 17.28 3 17.5492 3.07689C17.7877 3.14499 18.0114 3.25685 18.209 3.40675C18.432 3.576 18.608 3.81067 18.96 4.28L20.9437 6.92489C21.4985 7.66472 21.776 8.03464 21.8724 8.43775C21.9575 8.79328 21.9434 9.16531 21.8319 9.51342C21.7054 9.90813 21.4009 10.2561 20.7919 10.9521L14.4082 18.2477C13.5768 19.198 13.161 19.6731 12.6685 19.8478C12.236 20.0012 11.764 20.0012 11.3315 19.8478C10.839 19.6731 10.4232 19.198 9.59175 18.2477Z"
				fill="currentColor"
			/>
			<path
				d="M12 21L3.20809 10.9521C2.59911 10.2561 2.29462 9.90813 2.16812 9.51342C2.05656 9.16531 2.04254 8.79328 2.12759 8.43775C2.22402 8.03464 2.50146 7.66472 3.05633 6.92489L5.04 4.28C5.392 3.81067 5.568 3.576 5.79105 3.40675C5.9886 3.25685 6.21232 3.14499 6.45077 3.07689C6.72 3 7.01334 3 7.6 3H12M12 21L20.7919 10.9521C21.4009 10.2561 21.7054 9.90813 21.8319 9.51342C21.9434 9.16531 21.9575 8.79328 21.8724 8.43775C21.776 8.03464 21.4985 7.66472 20.9437 6.92489L18.96 4.28C18.608 3.81067 18.432 3.576 18.2089 3.40675C18.0114 3.25685 17.7877 3.14499 17.5492 3.07689C17.28 3 16.9867 3 16.4 3H12M12 21L8 9M12 21L16 9M12 3L8 9M12 3L16 9M8 9H16M8 9H2.5M16 9H21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9934 2.25H8.02501C7.14501 2.25 6.70501 2.25 6.30116 2.36534C5.94348 2.46749 5.60791 2.63527 5.31158 2.86013C4.977 3.114 4.713 3.466 4.18501 4.17L2.86974 5.92369C2.03743 7.03344 1.62127 7.58832 1.47662 8.19299C1.47201 8.21225 1.4676 8.23155 1.46338 8.25088C1.47552 8.2503 1.48774 8.25 1.50002 8.25H7.56478L10.9934 2.25ZM1.51993 9.75C1.52557 9.76887 1.5314 9.7877 1.53742 9.80649C1.72716 10.3986 2.1839 10.9205 3.09738 11.9645L9.59176 19.3867C10.3394 20.2411 10.7509 20.7114 11.1843 20.9245L7.45946 9.75H1.51993ZM12.8158 20.9245C13.2492 20.7113 13.6607 20.241 14.4083 19.3867L20.9026 11.9645L20.9027 11.9645C21.8161 10.9205 22.2729 10.3986 22.4626 9.80649C22.4686 9.7877 22.4744 9.76887 22.4801 9.75H16.5406L12.8158 20.9245ZM22.5366 8.25088C22.5324 8.23155 22.528 8.21225 22.5234 8.19299C22.3787 7.58832 21.9626 7.03344 21.1303 5.92368L19.815 4.17L19.815 4.16999C19.287 3.466 19.023 3.114 18.6884 2.86013C18.3921 2.63527 18.0565 2.46749 17.6989 2.36534C17.295 2.25 16.855 2.25 15.975 2.25H13.0067L16.4353 8.25H22.5C22.5123 8.25 22.5245 8.25029 22.5366 8.25088ZM12 18.6283L9.04059 9.75H14.9595L12 18.6283ZM12 3.51167L9.29241 8.25H14.7076L12 3.51167Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 21L3.20809 10.9521C2.59911 10.2561 2.29462 9.90813 2.16812 9.51342C2.05656 9.16531 2.04254 8.79328 2.12759 8.43775C2.22402 8.03464 2.50146 7.66472 3.05633 6.92489L5.04 4.28C5.392 3.81067 5.568 3.576 5.79105 3.40675C5.9886 3.25685 6.21232 3.14499 6.45077 3.07689C6.72 3 7.01334 3 7.6 3H12M12 21L20.7919 10.9521C21.4009 10.2561 21.7054 9.90813 21.8319 9.51342C21.9434 9.16531 21.9575 8.79328 21.8724 8.43775C21.776 8.03464 21.4985 7.66472 20.9437 6.92489L18.96 4.28C18.608 3.81067 18.432 3.576 18.2089 3.40675C18.0114 3.25685 17.7877 3.14499 17.5492 3.07689C17.28 3 16.9867 3 16.4 3H12M12 21L8 9M12 21L16 9M12 3L16 9M8 9H16M8 9H5M8 9L10 6M16 9H19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 21L3.20809 10.9521C2.59911 10.2561 2.29462 9.90813 2.16812 9.51342C2.05656 9.16531 2.04254 8.79328 2.12759 8.43775C2.22402 8.03464 2.50146 7.66472 3.05633 6.92489L5.04 4.28C5.392 3.81067 5.568 3.576 5.79105 3.40675C5.9886 3.25685 6.21232 3.14499 6.45077 3.07689C6.72 3 7.01334 3 7.6 3H12M12 21L20.7919 10.9521C21.4009 10.2561 21.7054 9.90813 21.8319 9.51342C21.9434 9.16531 21.9575 8.79328 21.8724 8.43775C21.776 8.03464 21.4985 7.66472 20.9437 6.92489L18.96 4.28C18.608 3.81067 18.432 3.576 18.2089 3.40675C18.0114 3.25685 17.7877 3.14499 17.5492 3.07689C17.28 3 16.9867 3 16.4 3H12M12 21L8 9M12 21L16 9M12 3L8 9M12 3L16 9M8 9H16M8 9H2.5M16 9H21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.02498 2.25C7.14499 2.25 6.70499 2.25 6.30114 2.36534C5.94346 2.46749 5.60789 2.63527 5.31156 2.86013C4.97698 3.114 4.71298 3.466 4.18498 4.17L2.86972 5.92369C2.0374 7.03344 1.62124 7.58832 1.4766 8.19299C1.34903 8.72627 1.37006 9.28432 1.5374 9.80649C1.72714 10.3986 2.18388 10.9205 3.09735 11.9645L9.59174 19.3867C10.4232 20.3369 10.839 20.8121 11.3315 20.9867C11.764 21.1401 12.236 21.1401 12.6684 20.9867C13.161 20.8121 13.5767 20.3369 14.4082 19.3867L20.9026 11.9645C21.8161 10.9205 22.2728 10.3986 22.4626 9.80649C22.6299 9.28432 22.6509 8.72627 22.5234 8.19299C22.3787 7.58832 21.9626 7.03344 21.1302 5.92368L19.815 4.17C19.287 3.466 19.023 3.114 18.6884 2.86013C18.3921 2.63527 18.0565 2.46749 17.6988 2.36534C17.295 2.25 16.855 2.25 15.975 2.25H8.02498Z"
				fill="currentColor"
			/>
			<path
				d="M1.3963 9C1.40622 9.27275 1.45337 9.54414 1.53744 9.80648C1.72718 10.3985 2.18391 10.9205 3.09739 11.9645L9.59177 19.3867C10.4233 20.3369 10.839 20.8121 11.3316 20.9867C11.764 21.1401 12.236 21.1401 12.6685 20.9867C13.161 20.8121 13.5768 20.3369 14.4083 19.3867L20.9027 11.9645C21.8161 10.9205 22.2729 10.3985 22.4626 9.80648C22.5467 9.54414 22.5938 9.27275 22.6037 9H1.3963Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
